export const WELCOME_PAGE = 'portal/welcomePage';
export const LANGUAGE = 'portal/language';
export const USER_NAME = 'portal/userName';
export const USER_ID = 'portal/userId';
export const USER_CONTACT_ID = 'portal/contactId';
export const USER_COMPANIES = 'portal/companies';
export const USER_LOGIN = 'portal/loginName';
export const ACCESS_TOKEN = 'portal/accessToken';
export const CUSTOMER_PORTAL_CONFIG = 'portal/customerPortalConfig';
export const DEFAULT_TEMPLATES = 'portal/DEFAULT_TEMPLATES';
export const SELECTED_TIME_PERIOD = 'portal/SELECTED_TIME_PERIOD';
export const CURRENT_TICKET_STATUS_TAB = 'portal/CURRENT_TICKET_STATUS_TAB';
export const COMPANY_ADDRESSBOOK_ID = 'portal/COMPANY_ADDRESSBOOK_ID';
export const CACHED_COMPANIES = 'portal/CACHED_COMPANIES';
export const CACHED_TICKET_FILTERS = 'portal/CACHED_TICKET_FILTERS';
export const GET_SUPPORT_KEYUSER_LOGIN = 'portal/Get Support Keyuser Login';
export const MAKE_REQUEST_KEY = 'Make Request';
export const GET_SUPPORT_KEY = 'Get Support';
export const DEFAULT_STEPPER_ITEM_IDS = {
  [MAKE_REQUEST_KEY]: 'portal/DEFAULT_MAKE_REQUEST_ID',
  [GET_SUPPORT_KEY]: 'portal/DEFAULT_GET_SUPPORT_ID'
};

export const TICKET_PRIORITYS = 'portal/TICKET_PRIORITYS';
export const TOPIC_TYPES = 'portal/TOPIC_TYPES';
export const DEFAULT_LANG = 'portal/DEFAULT_LANG';
export const TOPIC_TYPES_MAPPER = 'portal/TOPIC_TYPES_MAPPER';
export const TICKET_FEATURES = 'portal/TOPIC_FEATURES';
export const MAX_SATISFACTION = 'portal/maxSatisfaction';
